import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faPenToSquare,
	faHome,
	faPieChart,
	faMobileAndroid,
	faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { Menu } from "antd";

export const adminHeaderMenuLeft = (
	<>
		{/* <div className="ant-menu-left-icon">
            <Link to="/subscribers/current">
                <span className="anticon">
                    <FontAwesomeIcon icon={faUsers} />
                </span>
                <Typography.Text>Subscribers</Typography.Text>
            </Link>
        </div> */}
	</>
);

export const adminHeaderDropDownMenuLeft = () => {
	const items = [
		// {
		//     key: "/subscribers/current",
		//     icon: <FontAwesomeIcon icon={faUsers} />,
		//     label: <Link to="/subscribers/current">Subscribers</Link>,
		// },
	];

	return <Menu items={items} />;
};

export const adminSideMenu = [
	{
		title: "Dashboard",
		path: "/dashboard",
		icon: <FontAwesomeIcon icon={faHome} />,
		moduleCode: "PAGE_DASHBOARD",
	},
	{
		title: "Evaluation",
		path: "/evaluation",
		icon: <FontAwesomeIcon icon={faPenToSquare} />,
		moduleCode: "PAGE_EVALUATION",
	},
	{
		title: "Student Schedule",
		path: "/student-schedule",
		icon: <FontAwesomeIcon icon={faUsers} />,
		moduleCode: "PAGE_STUDENT_SCHEDULE",
	},
	{
		title: "Reports",
		path: "/reports",
		icon: <FontAwesomeIcon icon={faPieChart} />,
		moduleCode: "PAGE_REPORTS",
	},
	{
		title: "MOBILE APK",
		path: "/mobile-apk",
		icon: <FontAwesomeIcon icon={faMobileAndroid} />,
		moduleCode: "PAGE_MOBILE_APK",
	},
];
